export enum IBPerformanceMeasuresTab {
	HeadlineMeasures = 'HEADLINE',
	SubjectAttainment = 'ATTAINMENT',
	SubjectAreaDistribution = 'DISTRIBUTION',
	StudentLevel = 'STUDENT_LEVEL',
	StrategicValueAdded = 'STRATEGIC_VA',
}
